import React from 'react';
import clsx from 'clsx';
import { Typography } from '@/components/common';

interface StepTrackerProps {
	currentStep: number;
	totalSteps: number;
	className?: string;
	showLabel?: boolean;
}

export const StepTracker: React.FC<StepTrackerProps> = ({
	currentStep,
	totalSteps,
	className,
	showLabel = true,
}) => (
	<div className={clsx('flex items-center gap-2 shrink-0', className)}>
		<div className="flex items-center gap-1">
			{Array.from({ length: totalSteps }).map((_, index) => (
				<React.Fragment key={index}>
					{index > 0 && (
						<span
							className={clsx('w-6 h-0.5 rounded', {
								'bg-primary': index < currentStep,
								'bg-grey-10': index >= currentStep,
							})}
						/>
					)}
					<span
						className={clsx('w-2 h-2 rounded-full', {
							'bg-primary': index < currentStep,
							'bg-grey-10': index >= currentStep,
						})}
					/>
				</React.Fragment>
			))}
		</div>
		{showLabel && (
			<Typography type="regular-12" className="text-gray-0">
				{`Step ${currentStep} of ${totalSteps}`}
			</Typography>
		)}
	</div>
);
